import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import type { ReactNode } from "react";

type MyComponentProps = {
  children: ReactNode;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
};

const Modal = ({ children, setIsModalVisible, title }: MyComponentProps) => {
  const navigate = useNavigate();

  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <div className="absolute flex justify-center items-center top-0 bottom-0 left-0 right-0">
      <div onClick={onClose} className="z-[6000] fixed right-0 left-0 top-0 bottom-0 bg-black opacity-[0.5]"></div>
      <div className="z-[6001] fixed">
        <div className="relative pt-[25.2496px] mx-10 rounded-[12px] bg-white">
          <button
            onClick={onClose}
            className="absolute top-[25.2496px] right-[25.2496px] text-black hover:text-[#313131]"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="pb-[20px] px-[20px]">
            <div className="flex font-bold text-[#555555] mb-4">{title}</div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
